import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import "./rc-slider.css";
import Slider from "rc-slider";

function HandleTooltip(props) {
  const {
    value,
    children,
    visible,
    tipFormatter = (val) => `${val}`,
    ...restProps
  } = props;
  return (
    <Tooltip placement="top" title={tipFormatter(value)} {...restProps}>
      {children}
    </Tooltip>
  );
}

function TooltipSlider({ tipFormatter, tipProps, ...props }) {
  const tipHandleRender = (node, handleProps) => {
    return (
      <HandleTooltip
        value={handleProps.value}
        visible={handleProps.dragging}
        tipFormatter={tipFormatter}
        {...tipProps}
      >
        {node}
      </HandleTooltip>
    );
  };

  return <Slider {...props} handleRender={tipHandleRender} />;
}

export default TooltipSlider;
